export default __webpack_public_path__ + "static/Inter-BoldItalic-2d26c56a606662486796f6adffeeb0a2.woff2";